var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 28C1 42.9121 13.0879 55 28 55C42.9121 55 55 42.9121 55 28C55 13.0879 42.9121 1 28 1C13.0879 1 1 13.0879 1 28Z",
    stroke: "url(#paint0_linear_6443_18263)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6992 1.13672C30.6992 1.13672 38.7992 11.8017 38.7992 28.0017C38.7992 44.2017 30.6992 54.8667 30.6992 54.8667M25.2992 54.8667C25.2992 54.8667 17.1992 44.2017 17.1992 28.0017C17.1992 11.8017 25.2992 1.13672 25.2992 1.13672M2.7002 37.4517H53.2982M2.7002 18.5517H53.2982",
    stroke: "url(#paint1_linear_6443_18263)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6443_18263",
    x1: 22.2378,
    y1: 3.82857,
    x2: 59.914,
    y2: 11.6538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#E12541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#F85833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6443_18263",
    x1: 22.6,
    y1: 3.95115,
    x2: 58.0686,
    y2: 10.8885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#E12541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#F85833"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/languageIcon.716ef7b517c219b706d1a7cb6b5578ab.svg";
export { ForwardRef as ReactComponent };